import * as API from "middleware/api";

export const unsecuredLoansApplicationPre = (loanType) =>
    API.executeWithAccessToken("/unsecured.loans.application.pre", { loanType });

export const unsecuredLoansApplicationPreview = (params) =>
    API.executeWithAccessToken("/unsecured.loans.application.preview", {
        requestLoanSimulation: params,
    });

export const unsecuredLoansApplicationSend = (params) =>
    API.executeWithAccessToken("/unsecured.loans.application.send", params);

export const downloadUnsecuredLoanApplication = (unsecuredLoanPreview, accountLabel, format) =>
    API.executeWithAccessToken("/unsecured.loans.application.downloadPreview", {
        unsecuredLoanPreview,
        accountLabel,
        format,
    });

export const downloadUnsecuredLoanApplicationTerms = () =>
    API.executeWithAccessToken("/unsecured.loans.application.download.terms");

export const downloadUnsecuredLoanDetail = (loanDescription, product, installmentsStatus, format) =>
    API.executeWithAccessToken("/unsecured.loans.download.detail", {
        loanDescription,
        product,
        installmentsStatus,
        format,
    });

export const downloadUnsecuredLoanFeeDetail = (unsecuredLoanFeeDetail, format) =>
    API.executeWithAccessToken("/unsecured.loans.fee.detail.download", {
        unsecuredLoanFeeDetail,
        format,
    });

export const listLoans = () => API.executeWithAccessToken("/loans.list");
export const listLoansV2 = () => API.executeWithAccessToken("/unsecured.loans.list");
export const loanDetail = (loanNumber) => API.executeWithAccessToken("/unsecured.loans.read", {loanNumber});
export const cancelacionAnticipada = (params) => API.executeWithAccessToken("/unsecured.loans.payOff.send", params);
export const cancelacionAnticipadaPreview = (params) =>
    API.executeWithAccessToken("/unsecured.loans.payOff.preview", params);
export const otrosProductos = (params) => API.executeWithAccessToken("/productRequest.email.send", params);

export const listStatements = (idLoan, filters) => {
    const { status, pageNumber } = filters;

    return API.executeWithAccessToken("/loans.listStatements", {
        idLoan,
        requestedStatements: status,
        pageNumber,
    });
};

export const readLoan = (idLoan) => API.executeWithAccessToken("/loans.read", { idLoan });

export const downloadPayment = (idLoan, { ...filters }, fileFormat) =>
    API.executeWithAccessToken("/loans.downloadPayment", {
        idLoan,
        format: fileFormat,
        ...filters,
    });

export const requestCustomLoan = (params) => API.executeWithAccessToken("/request.custom.loan", params);

export const getRates = (params) => API.executeWithAccessToken("/unsecured.loans.getRates", params);

export const downloadLoansDetailRequest = (installmentList, format) =>
    API.executeWithAccessToken("/loans.detail.download", { installmentList, format });
